import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import icubanner from "../../assets/images/icu_banner.png";
import "./NursingCare.css";
import nursingcarebanner from "../../assets/images/nursingcare-banner.png";
import SearchIcon from "@mui/icons-material/Search";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import NursingcareData from "../../LabData/NursingcareData";
import Longterm from "./Longterm";
import { fetchAPI } from "../../utils/api";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import EventIcon from "@mui/icons-material/Event";
import nurgincareimg1 from "../../assets/images/nurgincare_img_1.png";
import Testimonial from "../../layout/Home/Testimonial";
import Review from "../../layout/Home/Review";
import nursingbanner from "../../assets/images/nursing-banner.png";
import n2 from "../../assets/images/n2.png";

import Sidedrawer from "../../components/Sidedrawer";
import PhysiotherapyServices from "./PhysiotherapyServices";

import faqimage from "../../assets/images/faq-img.jpg";
import Accordion from "react-bootstrap/Accordion";
import FaqData from "../../layout/Faqdata"; 

const steps = [
  {
    id: 1,
    title: "Book Online",
    desc: "Fill the form or call us",
  },
  {
    id: 2,
    title: "Assessment Call",
    desc: "Doctor reviews patient needs",
  },
  {
    id: 3,
    title: "Equipment Setup",
    desc: "Team arrives with all gear",
  },
  {
    id: 4,
    title: "Care Begins",
    desc: "Nurse starts 24/7 care",
  },
];

export default function NursingCare() {
  const [nursingData, setNursingData] = useState(NursingcareData);
  const [expanded, setExpanded] = useState({});
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedShortTerm, setSelectedShortTerm] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);

  const [homeData, setHomeData] = useState({
    testimonials: [],
  });

  useEffect(() => {
    const saved = localStorage.getItem("selectedShortTerm");
    if (saved) {
      try {
        setSelectedShortTerm(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse selectedShortTerm", e);
      }
    }
  }, []);

  const handleCheckboxChange = (service) => {
    setSelectedShortTerm((prev) => {
      const exists = prev.find((item) => item.id === service.id);
      let updated;
      if (exists) {
        updated = prev.filter((item) => item.id !== service.id);
      } else {
        updated = [...prev, service];
      }
      localStorage.setItem("selectedServicesCart", JSON.stringify(updated));
      localStorage.setItem("selectedShortTerm", JSON.stringify(updated));
      localStorage.setItem("activeCartType", "services");
      window.dispatchEvent(new Event("cartUpdated"));
      return updated;
    });
  };

  const filteredNursingData = nursingData
    .map((category) => {
      const services = Array.isArray(category.services)
        ? category.services
        : [];
      const matchedServices = services.filter((service) => {
        const serviceName =
          service && typeof service.name === "string" ? service.name : "";
        return serviceName.toLowerCase().includes(searchQuery.toLowerCase());
      });

      const categoryName =
        category && typeof category.servicesname === "string"
          ? category.servicesname
          : "";
      const isCategoryMatch = categoryName
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const servicesToKeep = isCategoryMatch ? services : matchedServices;

      if (servicesToKeep.length > 0) {
        return {
          ...category,
          totalservices: `${servicesToKeep.length} Service${servicesToKeep.length > 1 ? "s" : ""}`,
          services: servicesToKeep,
        };
      }
      return null;
    })
    .filter(Boolean);
  const [serviceDetail, setServiceDetail] = useState({
    title: "Nursing Care",
    subtitle: "Professional nursing care at your <span>Doorstep</span>",
    description:
      "All nurses are background-verified, clinically trained, and matched to your patient's specific condition. Select services below to build your care plan.",
    image: nursingcarebanner,
  });

  useEffect(() => {
    fetchAPI("CaregiverController/services")
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.result)) {
          const service = data.result.find((s) => parseInt(s.service_id) === 1);
          if (service) {
            setServiceDetail({
              title: service.service_title,
              subtitle: service.service_sub_title,
              description: service.service_description,
              image: service.service_image || nursingcarebanner,
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching service details:", err);
      });
  }, []);

  useEffect(() => {
    fetchAPI("CaregiverController/packages", {
      method: "POST",
      body: JSON.stringify({
        service_id: 1,
        service_type_id: 1,
      }),
    })
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.result)) {
          const mapped = data.result.map((cat) => {
            return {
              id: parseInt(cat.package_category_id),
              servicesname: cat.package_category_title,
              totalservices: `Total ${cat.packages.length} Service${cat.packages.length > 1 ? "s" : ""}`,
              services: cat.packages.map((pkg) => {
                const priceVal = parseFloat(pkg.price);
                const salePriceVal = parseFloat(pkg.sale_price);
                let offerText = "Special Price";
                if (priceVal > 0 && salePriceVal > 0) {
                  const pct = Math.round(
                    ((priceVal - salePriceVal) / priceVal) * 100,
                  );
                  if (pct > 0) {
                    offerText = `${pct}% Off`;
                  }
                }
                return {
                  id: parseInt(pkg.package_id),
                  name: pkg.package_title,
                  duration: pkg.duration,
                  offer: offerText,
                  price: `₹${pkg.sale_price}`,
                  oldPrice: pkg.price ? `(₹${pkg.price})` : "",
                  subtitle: pkg.package_subtitle,
                };
              }),
            };
          });
          setNursingData(mapped);
        }
      })
      .catch((err) => {
        console.warn(
          "Failed to load short term packages, using static fallback",
          err,
        );
      });
  }, []);

  return (
    <>
      <Header />

      {/* <section>
        <div className="container-fluid">
          <div className="doctor-banner">
            <img src={nursingbanner} alt="" className="img-fluid" />
          </div>
        </div>
      </section> */}

      <Sidedrawer
        open={open}
        setOpen={setOpen}
        category={activeCategory}
        selectedServices={selectedShortTerm}
        onServiceToggle={handleCheckboxChange}
      />

      <div className="caregiver_services nurgincare_services">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-6 col-xl-5 col-lg-4 col-md-4 col-12">
              <div className="caregiver_ser_title text-start">
                <h1>
                  <span>Nursing Care </span> Service at Home in Jaipur
                </h1>
                <p>
                  Get professional <a href="/home-nursingcare">nursing care</a> at home with certified nurses, personalized medical support, and compassionate healthcare services at your doorstep.
                </p>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-7 col-lg-8 col-md-8 col-12">
              <div className="term-search-outer">
                <div className="search-main-outer">
                  <div className="search_icon_animation">
                    <div className={`search-box ${searchOpen ? "active" : ""}`}>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />

                      <button onClick={() => setSearchOpen(!searchOpen)}>
                        <SearchIcon />
                      </button>
                    </div>
                  </div>
                  <div className="search_sec_long">
                    <form onSubmit={(e) => e.preventDefault()}>
                      <input
                        type="text"
                        placeholder="Search Service...."
                        className="search_input_long"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <button type="button" className="search_btn_long">
                        SEARCH
                      </button>
                    </form>
                  </div>
                </div>

                <div className="tabs_sec_services">
                  <ul
                    className="nav tabs_sec_main nav-pills"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="pills-short-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-short"
                        type="button"
                        role="tab"
                        aria-controls="pills-short"
                        aria-selected="true"
                      >
                        Short Term
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="pills-long-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-long"
                        type="button"
                        role="tab"
                        aria-controls="pills-long"
                        aria-selected="false"
                      >
                        Long Term
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-short"
              role="tabpanel"
              aria-labelledby="pills-short-tab"
              tabindex="0"
            >
              <div className="row">
                <div className="col-lg-12">
                  <div className="caregiver_serv_boxes">
                    <div className="row">
                      {filteredNursingData.map((nursingcare) => (
                        <div
                          className="col-lg-6 col-md-6 col-12 nursingcare-service-box"
                          key={nursingcare.id}
                        >
                          <div className="main_svis_box">
                            <div className="uper_sec_box">
                              <label>{nursingcare.servicesname}</label>
                              <p className="btn_sev_box_uper">
                                {nursingcare.totalservices}
                              </p>
                            </div>
                            <div className="lower_sec_box">
                              <div className="services_list_caregiver">
                                <ul className="service_list">
                                  {(expanded[nursingcare.id]
                                    ? nursingcare.services
                                    : nursingcare.services.slice(0, 3)
                                  ).map((service) => (
                                    <li
                                      key={service.id}
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        if (
                                          !selectedShortTerm.find(
                                            (item) => item.id === service.id,
                                          )
                                        ) {
                                          handleCheckboxChange(service);
                                        }
                                        setActiveCategory(nursingcare);
                                        setOpen(true);
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`service-${nursingcare.id}-${service.id}`}
                                        checked={
                                          !!selectedShortTerm.find(
                                            (item) => item.id === service.id,
                                          )
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          if (
                                            !selectedShortTerm.find(
                                              (item) => item.id === service.id,
                                            )
                                          ) {
                                            handleCheckboxChange(service);
                                          }
                                          setActiveCategory(nursingcare);
                                          setOpen(true);
                                        }}
                                      />

                                      <div className="service_content">
                                        <label
                                          htmlFor={`service-${nursingcare.id}-${service.id}`}
                                          className="service_title"
                                        >
                                          {service.name}
                                        </label>
                                        <p className="service-desc">
                                          {service.subtitle}
                                        </p>
                                      </div>

                                      <div className="service_price">
                                        <span className="discount">
                                          {service.offer}
                                        </span>

                                        <div className="price_box price_sec-box">
                                          <span className="current_price">
                                            {service.price}
                                          </span>
                                          <span className="old_price">
                                            {service.oldPrice}
                                          </span>
                                        </div>

                                        <div className="service_time">
                                          <small>Duration : </small>
                                          <span>{service.duration}</span>
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>

                              {/* <button
                                          type="button"
                                          onClick={() =>
                                            setExpanded((prev) => ({
                                              ...prev,
                                              [nursingcare.id]:
                                                !prev[nursingcare.id],
                                            }))
                                          }
                                        >
                                          {expanded[nursingcare.id]
                                            ? "Show Less"
                                            : `View All ${nursingcare.totalservices}`}
                                        </button> */}
                              <button
                                className="view_all_ser_btn"
                                onClick={() => {
                                  setActiveCategory(nursingcare);
                                  setOpen(true);
                                }}
                              >
                                More Services
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="col-lg-12">
                        <div className="btn_nursing_care">
                          <Link to="/service-booking">Submit</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ==============long-term===================== */}

            <div
              className="tab-pane fade"
              id="pills-long"
              role="tabpanel"
              aria-labelledby="pills-long-tab"
              tabindex="0"
            >
              {/* <Longterm
                serviceId={1}
                serviceTitle={serviceDetail.title}
                serviceDesc={serviceDetail.description}
                searchQuery={searchQuery}
              /> */}

              <PhysiotherapyServices serviceId={1} searchQuery={searchQuery} />
            </div>
          </div>

          {/* old desin    start         */}
        </div>
      </div>

      <section className="whychse caregiver_why_content">
        <div className="container-fluid">
          <div className="section_heading">
            <div className="content_part text-center col-lg-12  col-sm-12 col-12">
              <span className="short_title">Why Choose Us</span>
              <h2>
                Why Families Trust Our <span>Nursing Care</span> Service
              </h2>
              <p>
                Receive hospital-quality nursing care at home with experienced nurses providing personalised healthcare for every stage of recovery.
              </p>
            </div>
          </div>
          <div className="row g-3">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Experienced Nursing Professionals</h3>
                <p>Certified nurses delivering safe, compassionate, and professional healthcare with extensive clinical experience.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <LocalOfferOutlinedIcon />
                <h3>Personalized Nursing Plans</h3>
                <p>Customised nursing plans designed according to every patient's unique healthcare and recovery needs.</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Affordable Healthcare</h3>
                <p>Affordable nursing services with transparent pricing and flexible care plans for everyone. </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <AddShoppingCartOutlinedIcon />
                <h3>Hospital-Quality Care</h3>
                <p>Hospital-quality nursing care delivered safely and comfortably in your home's familiar environment. </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="icu_content_section">
        <div className="container-fluid">
          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={nurgincareimg1} alt="nursingcare-img-1" />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">CaresAtHome</p>
                  <h4 className="heading-about">
                    What Does <span>Nursing Care</span> at Home Include?
                  </h4>
                  <p className="pera-about">
                    Professional <a href="/home-nursingcare">nursing care at home</a> provides personalized medical support, helping patients recover safely and comfortably without frequent hospital visits. Our experienced nurses follow strict clinical protocols while delivering compassionate care tailored to each patient's health needs.
                  </p>
                  <p className="pera-about">
                   Our nursing care service in Jaipur includes medication management, injections, IV infusion, wound dressing, catheter care, tracheostomy care, Ryle's tube care, oxygen support, post-operative care, elderly care, and rehabilitation services.
                  </p>
                  <div className="about_bullet_point">
                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h4>Home & Hospital Support</h4>
                        <p>Receive complete nursing assistance after hospital discharge, reducing unnecessary readmissions while ensuring continuous recovery at home.</p>
                      </div>
                    </div>

                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h4>Personalized Patient Monitoring</h4>
                        <p>Regular health assessments, medication tracking, vital sign monitoring, and ongoing communication with families ensure better patient outcomes.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about_us_first_sec nursing_care_c2">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">CaresAtHome</p>
                  <h4 className="heading-about">
                    Benefits of Choosing <span>Nursing Care</span> at Home
                  </h4>
                  <p className="pera-about">
                   Choosing a professional <a href="/home-nursingcare">nursing care at-home</a> service ensures patients receive expert medical attention in a safe and familiar environment. It promotes faster recovery, reduces unnecessary hospital visits, and provides families with peace of mind through continuous, personalised care.
                  </p>
                  <div className="about_bullet_point">
                    <ul className="bullet_points_care about_point-self">
                      <li>
                        <CheckCircleIcon /> Faster Recovery in a Familiar Environment
                      </li>
                      <li>
                        <CheckCircleIcon /> Reduced Hospital Visits{" "}
                      </li>
                      <li>
                        <CheckCircleIcon /> Lower Risk of Infections
                      </li>
                      <li>
                        <CheckCircleIcon />Personalized One-to-One Care
                      </li>
                      <li>
                        <CheckCircleIcon /> Emotional Support for Patients
                      </li>
                      <li>
                        <CheckCircleIcon /> Better Medication Management
                      </li>
                      <li>
                        <CheckCircleIcon /> Affordable Long-Term Healthcare
                      </li>
                      <li>
                        <CheckCircleIcon /> Professional Medical Supervision
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={n2} alt="nursingcare-img-1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Testimonial testimonials={homeData.testimonials} />
      

       <div className="faq_sec">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4">
                  <div className="section_heading ">
                    <h4>
                      Frequently Asked <span>Questions </span>
                    </h4>
                  </div>
                  <div className="faq-image">
                    <img src={faqimage} alt="nursingcare-faq-img" className="img-fluid" />
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="faq-main">
                     <Accordion defaultActiveKey="0">
                        {FaqData
                          .filter((item) => item.page === "nursingcare")
                          .map((item, index) => (
                            <Accordion.Item
                              eventKey={index.toString()}
                              key={item.id}
                            >
                              <Accordion.Header as="h5">{item.title}</Accordion.Header>
                              <Accordion.Body>{item.content}</Accordion.Body>
                            </Accordion.Item>
                          ))}
                      </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>

            
      <Footer />
    </>
  );
}
